import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { logger } from './lib/telemetry/logger';
import './index.css';

// Handle chunk loading errors (occurs when new deployment invalidates old chunks)
// This happens when users have cached old version and new deployment removes old chunk files
window.addEventListener('vite:preloadError', (event) => {
  console.warn('Chunk preload error detected, reloading page...', event);
  // Prevent infinite reload loop by checking sessionStorage
  const reloadKey = 'chunk-reload-attempted';
  if (!sessionStorage.getItem(reloadKey)) {
    sessionStorage.setItem(reloadKey, 'true');
    window.location.reload();
  } else {
    // Already tried reloading, clear the flag for next time
    sessionStorage.removeItem(reloadKey);
    console.error('Chunk loading failed after reload, showing error');
  }
});

// Clear reload flag on successful load
window.addEventListener('load', () => {
  sessionStorage.removeItem('chunk-reload-attempted');
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

// Log app initialization
logger.info('Talksy app initializing', {
  version: '0.1.0',
  environment: import.meta.env.MODE,
});

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary
      onError={(error, errorInfo) => {
        logger.error('React error boundary caught error', error, {
          componentStack: errorInfo.componentStack,
        });
      }}
    >
      <App />
    </ErrorBoundary>
  </StrictMode>
);
